/**
 * The chart chrome's stacking scale — the single source of truth for every
 * z-index in charts-core. Values are applied via `style={{ zIndex }}` (not
 * Tailwind arbitrary classes) so they can reference these constants; Tailwind
 * cannot generate `z-[…]` classes from runtime values.
 *
 * The scale, bottom to top:
 *  - CHROME (99): floating chart chrome — toolbar/drawing-bar dropdowns,
 *    indicator picker. Above the canvas, below panel-level popovers.
 *  - PANEL (100): panel-level popovers — sync toggles, settings popover.
 *  - MODAL (1000): the settings modal, indicator/overlay drawers, context
 *    menus. Above all chart chrome.
 *  - MODAL_CHROME (1001): submenus that must sit on their parent context
 *    menu.
 *  - MODAL_POPPER (1200): poppers spawned from INSIDE a modal/drawer
 *    (DrawerSelect's option list) — must beat the modal that hosts them.
 */
export const Z_CHROME = 99
export const Z_PANEL = 100
export const Z_MODAL = 1000
export const Z_MODAL_CHROME = 1001
export const Z_MODAL_POPPER = 1200
